import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { MarketScreenerFrame, MarketScreenerStream } from '@/types/generated/public_api'

// Every subscriber shares the flat 'marketScreenerStream' listener key, so frames
// for other venue filters arrive here too. The consumer drops those by comparing
// `filterToken` (see screener-frame.ts) — it needs the frame either way to tell a
// foreign token from its own.
export const useMarketScreenerStream = createStreamHook<MarketScreenerStream, MarketScreenerFrame>({
  channelKey: 'marketScreenerStream',
  extractResponse: (message) => message.data?.marketScreenerFrame,
  getPayloadDeps: (p) => [p.exchanges],
  listenerChannelKey: 'marketScreenerStream',
})
